import './custom-filter.component.ajscss';

import { ng1Destroy } from '@commons/util/utilities/rx';
import { HypervisionState } from '@hypervision/hypervision-routing.module';
import { IComponentController, IComponentOptions } from 'angular';

import { MessagingService } from '@contact/upgrade';

import { ISkillViewFilterService } from '../filter.service';
import templateUrl from './custom-filter.component.ajs.html';

const MODULE_NAME = 'skillViewCustomFilter';

class CustomFilterCtrl implements IComponentController {
  public name = MODULE_NAME;

  public onChangeFilterState: Function;
  public isFilterActive = false;

  constructor(private readonly skillFilterHypervision: ISkillViewFilterService, private readonly messaging: MessagingService) {}

  $onInit() {
    // When the filter is updated
    this.messaging
      .forLocal()
      .listen$<any>('filterChanged')
      .pipe(ng1Destroy(this))
      .subscribe(() => {
        this.isFilterActive = this.skillFilterHypervision.isFilterActive(HypervisionState.SKILL_CUSTOM);
      });
  }

  onChangeState() {
    this.onChangeFilterState({ $event: { filterState: true } });
  }
}

export class CustomFilter implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    onChangeFilterState: '&',
  };
  controller = ['skillFilterHypervision', 'messaging', CustomFilterCtrl];
}

export default MODULE_NAME;
